import { render, staticRenderFns } from "./receOffsetPayAction.vue?vue&type=template&id=3aedd7f8&scoped=true"
import script from "./receOffsetPayAction.vue?vue&type=script&lang=js"
export * from "./receOffsetPayAction.vue?vue&type=script&lang=js"
import style0 from "./receOffsetPayAction.vue?vue&type=style&index=0&id=3aedd7f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aedd7f8",
  null
  
)

export default component.exports